import { render, staticRenderFns } from "./ProductInstances.vue?vue&type=template&id=779c90a4&"
import script from "./ProductInstances.vue?vue&type=script&lang=js&"
export * from "./ProductInstances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports